// removed by extract-text-webpack-plugin
module.exports = {"block":"Nav__block___3ZtNe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav.css
// module id = 109
// module chunks = 0